import { Component } from 'react';
import { assoc, concat, without } from 'ramda';

import { MapNoteSheetNew } from '../../components';
import s from './HostStyles.module.scss';

const initialState = {
    showSheet: true,
    userEmail: 'test@test.com',
    updatedMapNoteFields: {},
};

export default class MapNoteSheetNewHost extends Component {
    constructor(props) {
        super(props);
        this.state = initialState;
    }

    onSubjectChange = text => {
        const { updatedMapNoteFields } = this.state;
        this.setState({ updatedMapNoteFields: assoc('subject', text, updatedMapNoteFields) });
    };

    onDescriptionChange = text => {
        const { updatedMapNoteFields } = this.state;
        this.setState({ updatedMapNoteFields: assoc('description', text, updatedMapNoteFields) });
    };

    onTypeChange = newValue => {
        const { updatedMapNoteFields } = this.state;
        this.setState({ updatedMapNoteFields: assoc('noteType', newValue, updatedMapNoteFields) });
    };

    onImageUpload = addedImages => {
        const { updatedMapNoteFields } = this.state;
        const newUploadedImageList = updatedMapNoteFields.uploadedImages ? concat(updatedMapNoteFields.uploadedImages, addedImages) : addedImages;
        this.setState({ updatedMapNoteFields: assoc('uploadedImages', newUploadedImageList, updatedMapNoteFields) });
    };

    onImageDelete = image => {
        const { updatedMapNoteFields } = this.state;
        this.setState({
            updatedMapNoteFields: assoc('uploadedImages', without([image], updatedMapNoteFields.uploadedImages), updatedMapNoteFields),
        });
    };

    render() {
        return (
            <div className={s.editor} style={{ padding: '100px' }}>
                {this.state.showSheet && (
                    <MapNoteSheetNew
                        updatedFields={this.state.updatedMapNoteFields}
                        onSubjectChange={this.onSubjectChange}
                        onDescriptionChange={this.onDescriptionChange}
                        onTypeChange={this.onTypeChange}
                        onImageUpload={this.onImageUpload}
                        onImageDelete={this.onImageDelete}
                        onClose={() => this.setState({ showSheet: false })}
                        onSave={() => this.setState({ showSheet: false })}
                    />
                )}
                <button type="button" onClick={() => this.setState(initialState)} className={s.resetButton}>
                    Reset
                </button>
            </div>
        );
    }
}
